var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { reduxBind } from 'badphraim/ui/LitReduxMixinBase';
import { isErrorHTTP, isSuccessHTTP } from 'boost-api/APIRestClient';
import { MembersignupAPI } from 'boost-api/boost/signup/membersignup/MembersignupAPI';
import { css, html, LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { BoostPortalStore } from '../redux/BoostPortalStore';
import { litReduxBoostPortalMixin } from '../redux/LitReduxBoostPortalMixin';
import { router } from '../router/BoostPortalRouter';
import { BoostPortalMemberCompanySponsoredProgress } from '../components/BoostPortalMemberCompanySponsoredProgress';
import { BoostPortalMemberStandardConfirm } from '../components/BoostPortalMemberStandardConfirm';
import { BoostButton } from '../components/common/BoostButton';
import { BoostPortalChooseDepartment } from '../components/BoostPortalChooseDepartment';
import { BoostPortalChooseMembership } from '../components/BoostPortalChooseMembership';
import { BoostPortalPersonalInformation, } from '../components/BoostPortalPersonalInformation';
import { BoostPortalValidateSponsorCode } from '../components/BoostPortalValidateSponsorCode';
import { BoostStepIndicator } from '../components/common/BoostStepIndicator';
import { SnackBar } from 'common-uicomponents/components/SnackBar';
import { BoostStatusContainer } from '../components/common/BoostStatusContainer';
import { BoostPortalHeader } from '../components/BoostPortalHeader';
import { BoostPortalParamsHandler } from '../helpers/BoostPortalParamsHandler';
import { StatusCode } from 'badphraim/http/StatusCode';
import { TrackingEvent } from '../tracking/TrackingEvent';
import { TrackingFactorySingleton } from '../tracking/TrackingFactorySingleton';
import { BoostPortalTranslateMixin } from '../translation/TranslateBoostPortalMixin';
let BoostPortalRegisterMemberCompanySponsoredView = class BoostPortalRegisterMemberCompanySponsoredView extends BoostPortalTranslateMixin(litReduxBoostPortalMixin(LitElement)) {
    static get is() {
        return 'boost-portal-register-member-company-sponsored-view';
    }
    static get styles() {
        return css `
            :host {
                width: 90%;
            }

            h3 {
                color: var(--boost-font-color-dark);
                font-weight: 500;
                margin-bottom: 10px;
            }
        `;
    }
    constructor() {
        super();
        this.currentStep = 1;
        this.isValidSponsorCode = false;
        this.memberExists = false;
        this.meetsMinimumAge = true;
        this.updateComplete.then(() => this.onUpdateComplete());
    }
    onUpdateComplete() {
        return __awaiter(this, void 0, void 0, function* () {
            const urlParameters = new URLSearchParams(location.search);
            const memberCreated = urlParameters.get('success');
            if (memberCreated) {
                this.memberCreated = memberCreated;
            }
            const departmentIdStr = BoostPortalParamsHandler.getParameter('departmentId');
            const membershipIdStr = BoostPortalParamsHandler.getParameter('membershipId');
            if (departmentIdStr) {
                const departmentId = parseInt(departmentIdStr);
                TrackingFactorySingleton.asyncTracker((tracker) => __awaiter(this, void 0, void 0, function* () {
                    var _a, _b, _c;
                    const departmentName = (_c = (_b = (_a = this.departments) === null || _a === void 0 ? void 0 : _a.find((department) => (department.id = departmentId))) === null || _b === void 0 ? void 0 : _b.navn) !== null && _c !== void 0 ? _c : 'Avdeling med ukjent navn ' + departmentId;
                    tracker.completedEvent(TrackingEvent.SelectedDepartment, {
                        departmentId,
                        departmentName,
                    });
                }));
                this.dispatch(BoostPortalStore.Actions.SetSelectedDepartmentId(departmentId));
            }
            if (membershipIdStr) {
                const membershipId = parseInt(membershipIdStr);
                // Tracking events må legges inn på strategiske plasser i løypen
                TrackingFactorySingleton.asyncTracker((tracker) => __awaiter(this, void 0, void 0, function* () {
                    var _a, _b, _c;
                    const membershipName = (_c = (_b = (_a = this.memberships) === null || _a === void 0 ? void 0 : _a.find((membership) => membership.id == membershipId)) === null || _b === void 0 ? void 0 : _b.title) !== null && _c !== void 0 ? _c : 'Medlemskap med ukjent navn ' + membershipId;
                    tracker.completedEvent(TrackingEvent.SelectedMembership, {
                        membershipId,
                        membershipName,
                    });
                }));
                this.dispatch(BoostPortalStore.Actions.SetSelectedMembershipId(membershipId));
            }
        });
    }
    /** @override */ render() {
        return html `
            <boost-portal-header .viewLoginButton="${false}"></boost-portal-header>
            <h3>${this.boostTranslate('company-sponsored')}</h3>

            ${this.memberCreated
            ? html `
                      ${this.memberCreated === 'true'
                ? html `
                                <boost-status type="success">
                                    <p>${this.boostTranslate('sponsor-member-created-info')}</p>
                                    <p>${this.boostTranslate('invoice-info')}</p>
                                </boost-status>
                            `
                : html `
                                <boost-status type="danger">
                                    ${this.boostTranslate('spons-status-container-danger')}
                                </boost-status>
                            `}
                  `
            : html `
                      <boost-step-indicator
                          currentStep="${this.currentStep}"
                          .steps="${this._getSteps(this.currentStep)}"
                          @currentStep-changed="${(event) => {
                this.currentStep = event.detail.currentStep;
            }}"
                      ></boost-step-indicator>

                      ${this._showViewForCurrentStep(this.currentStep)}
                  `}
        `;
    }
    /** @override */ updated(changedProperties) {
        changedProperties.forEach((_oldValue, propertyName) => {
            switch (propertyName) {
                case 'currentStep':
                    this._currentStepObserver();
                    break;
            }
        });
        super.updated(changedProperties);
    }
    _createMember(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const buttonElement = event.srcElement;
            if (buttonElement.disabled) {
                return;
            }
            if (!this.isValidSponsorCode ||
                !this.sponsorCode ||
                !this.memberInformation ||
                !this._isValidMemberInformation() ||
                !this.selectedDepartmentId ||
                !this.selectedMembershipId) {
                return;
            }
            this.memberInformation.sponsor_code = this.sponsorCode;
            this.memberInformation.departmentId = this.selectedDepartmentId;
            this.memberInformation.membershipId = this.selectedMembershipId;
            this.memberInformation.netsCallbackUrl =
                router.baseUrl + this.centerShort + '/avtalegiro?departmentId=' + this.selectedDepartmentId;
            this.requestUpdate('memberInformation');
            buttonElement.setLoading(true);
            const createdMemberResult = yield MembersignupAPI.postV1BoostsignupMember(this.memberInformation);
            if (isSuccessHTTP(createdMemberResult)) {
                this.memberInformation = createdMemberResult;
                this.dispatch(BoostPortalStore.Actions.SetMemberInformation(this.memberInformation));
                TrackingFactorySingleton.asyncTracker((tracker) => tracker.completedEvent(TrackingEvent.PersonalInformationFilled));
                window.location.replace(window.location.href + '?success=true');
            }
            else if (isErrorHTTP(createdMemberResult)) {
                if (createdMemberResult.error.http_status === StatusCode.CONFLICT) {
                    this.memberExists = true;
                }
                else {
                    SnackBar.pushError(createdMemberResult.error);
                }
            }
            buttonElement.setLoading(false);
        });
    }
    _currentStepObserver() {
        if (this.currentStep > this._determineCurrentStep()) {
            this.currentStep = this._determineCurrentStep();
        }
    }
    _determineCurrentStep() {
        if (!this.isValidSponsorCode) {
            return 1;
        }
        else if (!this.selectedDepartmentId || !this.selectedMembershipId) {
            return 2;
        }
        return 3;
    }
    _getSteps(currentStep) {
        const steps = [
            {
                title: this.boostTranslate('code'),
                isActive: currentStep === 1,
                subtitle: '',
            },
            {
                title: this.boostTranslate('agreement'),
                isActive: currentStep === 2,
                subtitle: '',
            },
            {
                title: this.boostTranslate('personalia'),
                isActive: currentStep === 3,
                subtitle: '',
            },
        ];
        return steps;
    }
    _isValidMemberInformation() {
        if (!this.memberInformation) {
            return false;
        }
        if (!this.memberInformation.firstname ||
            !this.memberInformation.lastname ||
            !this.memberInformation.address ||
            !this.memberInformation.postal_code ||
            !this.memberInformation.municipality ||
            !this.memberInformation.phone_number ||
            !this.memberInformation.email ||
            !this.memberInformation.date_of_birth ||
            !this.memberInformation.gender ||
            !this.memberInformation.approve_tos) {
            return false;
        }
        return true;
    }
    _showViewForCurrentStep(currentStep) {
        var _a, _b, _c;
        switch (currentStep) {
            case 1:
                return html `
                    <boost-portal-validate-sponsor-code
                        @isValidSponsorCode-changed="${(event) => {
                    this.isValidSponsorCode = event.detail.isValidSponsorCode;
                }}"
                    ></boost-portal-validate-sponsor-code>

                    <boost-status-container type="info">
                        ${this.boostTranslate('contact-for-company')}
                    </boost-status-container>

                    <div>
                        <boost-button
                            type="submit"
                            name="${this.boostTranslate('next-button')}"
                            @click="${() => {
                    if (!this.isValidSponsorCode) {
                        return;
                    }
                    this.currentStep += 1;
                }}"
                            ?disabled="${!this.isValidSponsorCode}"
                            width-full
                        ></boost-button>
                    </div>
                `;
            case 2:
                return html `
                    <boost-portal-member-company-sponsored-progress></boost-portal-member-company-sponsored-progress>

                    <boost-portal-choose-department></boost-portal-choose-department>

                    <boost-portal-choose-membership ?isSponsor="${true}"></boost-portal-choose-membership>

                    <div>
                        <boost-button
                            type="submit"
                            name="${this.boostTranslate('next-button')}"
                            @click="${() => {
                    if (!this.selectedDepartmentId || !this.selectedMembershipId) {
                        return;
                    }
                    const membershipId = this.selectedMembershipId;
                    // Tracking events må legges inn på strategiske plasser i løypen
                    TrackingFactorySingleton.asyncTracker((tracker) => __awaiter(this, void 0, void 0, function* () {
                        var _a, _b, _c;
                        const membershipName = (_c = (_b = (_a = this.memberships) === null || _a === void 0 ? void 0 : _a.find((membership) => membership.id == membershipId)) === null || _b === void 0 ? void 0 : _b.title) !== null && _c !== void 0 ? _c : 'Medlemskap med ukjent navn ' + membershipId;
                        tracker.completedEvent(TrackingEvent.SelectedMembership, {
                            membershipId,
                            membershipName,
                        });
                    }));
                    this.currentStep += 1;
                }}"
                            ?disabled="${!this.selectedDepartmentId || !this.selectedMembershipId}"
                            width-full
                        ></boost-button>
                    </div>
                `;
            case 3:
                return html `
                    <boost-portal-member-company-sponsored-progress></boost-portal-member-company-sponsored-progress>

                    <boost-portal-personal-information
                        @memberPhoneNumber-changed="${() => (this.memberExists = false)}"
                        @meetsMinimumAge="${(event) => (this.meetsMinimumAge = event.detail.value)}"
                        @memberExists-changed="${(event) => (this.memberExists = event.detail.memberExists)}"
                    ></boost-portal-personal-information>

                    ${this.memberExists
                    ? html `
                              <boost-status-container type="info">
                                  ${this.isLoggedIn()
                        ? this.boostTranslate('already-member')
                        : html `
                                            ${this.boostTranslateOutputHtml('earlier-member', {
                            url: router.baseUrl + this.centerShort + '/login',
                        })}
                                        `}
                              </boost-status-container>
                          `
                    : html `
                              ${!this.meetsMinimumAge
                        ? html `<boost-status-container type="info">
                                        ${this.boostTranslateOutputHtml('under-age', {
                            age: (_c = (_b = (_a = this.center) === null || _a === void 0 ? void 0 : _a.minimum_age) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : '',
                        })}
                                    </boost-status-container>`
                        : html `<div>
                                        <boost-button
                                            type="submit"
                                            name="${this.boostTranslate('next-button')}"
                                            @click="${this._createMember}"
                                            ?disabled="${!this._isValidMemberInformation()}"
                                            width-full
                                        ></boost-button>
                                    </div>`}
                          `}
                `;
        }
    }
    isLoggedIn() {
        var _a;
        return this.session && ((_a = this.loggedInProfile) === null || _a === void 0 ? void 0 : _a.memberid);
    }
};
BoostPortalRegisterMemberCompanySponsoredView._deps = [
    BoostButton,
    BoostStepIndicator,
    BoostPortalChooseDepartment,
    BoostPortalChooseMembership,
    BoostPortalPersonalInformation,
    BoostPortalMemberCompanySponsoredProgress,
    BoostPortalMemberStandardConfirm,
    BoostPortalValidateSponsorCode,
    BoostStatusContainer,
    BoostPortalHeader,
];
__decorate([
    reduxBind(BoostPortalStore.path('centerShort')),
    state(),
    __metadata("design:type", String)
], BoostPortalRegisterMemberCompanySponsoredView.prototype, "centerShort", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('center')),
    state(),
    __metadata("design:type", Object)
], BoostPortalRegisterMemberCompanySponsoredView.prototype, "center", void 0);
__decorate([
    state(),
    __metadata("design:type", Number)
], BoostPortalRegisterMemberCompanySponsoredView.prototype, "currentStep", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalRegisterMemberCompanySponsoredView.prototype, "isValidSponsorCode", void 0);
__decorate([
    state(),
    __metadata("design:type", String)
], BoostPortalRegisterMemberCompanySponsoredView.prototype, "memberCreated", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('memberInformation')),
    state(),
    __metadata("design:type", Object)
], BoostPortalRegisterMemberCompanySponsoredView.prototype, "memberInformation", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('selectedDepartmentId')),
    state(),
    __metadata("design:type", Number)
], BoostPortalRegisterMemberCompanySponsoredView.prototype, "selectedDepartmentId", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('departments')),
    state(),
    __metadata("design:type", Array)
], BoostPortalRegisterMemberCompanySponsoredView.prototype, "departments", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('memberships')),
    state(),
    __metadata("design:type", Array)
], BoostPortalRegisterMemberCompanySponsoredView.prototype, "memberships", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('selectedMembershipId')),
    state(),
    __metadata("design:type", Number)
], BoostPortalRegisterMemberCompanySponsoredView.prototype, "selectedMembershipId", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('sponsorCode')),
    state(),
    __metadata("design:type", String)
], BoostPortalRegisterMemberCompanySponsoredView.prototype, "sponsorCode", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('session')),
    state(),
    __metadata("design:type", String)
], BoostPortalRegisterMemberCompanySponsoredView.prototype, "session", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('loggedInProfile')),
    state(),
    __metadata("design:type", Object)
], BoostPortalRegisterMemberCompanySponsoredView.prototype, "loggedInProfile", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalRegisterMemberCompanySponsoredView.prototype, "memberExists", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalRegisterMemberCompanySponsoredView.prototype, "meetsMinimumAge", void 0);
BoostPortalRegisterMemberCompanySponsoredView = __decorate([
    customElement(BoostPortalRegisterMemberCompanySponsoredView.is),
    __metadata("design:paramtypes", [])
], BoostPortalRegisterMemberCompanySponsoredView);
export { BoostPortalRegisterMemberCompanySponsoredView };
